import { Component, OnInit, Input, EventEmitter, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  Tarea,
  DynamicComponentForm,
  Context,
  TaskEvent,
  ConfigFinishDefault,
  ConfirmComponent,
  Const,
  BaseControl,
  DocumentoInventario,
  Static,
  OrdenPestanas,
  TablaDatos,
  CondicionDocumento,
  Documento,
  Forma,
  FuncionDocumento,
  DocumentoGenerado,
  Datos,
  SubForma,
  Control,
  DocumentoDetalle,
  HistorialDocumento,
  RevisionDocumento,
} from '@app/shared';
import { DocumentExpInventoryFormConfig } from './shared/document-exp-inventory-form.config.service';
import { DocumentExpInventoryFormDataService } from './shared/document-exp-inventory-form.data.service';
import { DocumentExpInventoryFormService } from './shared/document-exp-inventory-form.form.service';
import { FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService, TabsetComponent } from 'ngx-bootstrap';
import { filter, find, findIndex } from 'lodash';
import { ThrowStmt } from '@angular/compiler';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { Subject } from 'rxjs';

interface OrderTabsView extends OrdenPestanas {
  view: boolean;
  complete?: boolean;
}


@Component({
  selector: 'iw-document-exp-inventory-form',
  templateUrl: './document-exp-inventory-form.component.html',
  styleUrls: ['./document-exp-inventory-form.component.scss'],
  providers: [
    DocumentExpInventoryFormDataService,
    DocumentExpInventoryFormService
  ]
})
export class DocumentExpInventoryFormComponent extends DynamicComponentForm implements OnInit {
  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<TaskEvent>;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Tarea actual
  task: Tarea;
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Define si la tarea esta finalizada
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // contiene la configuracion de la tabla
  settings = {};
  // informacion de datos a mostrar en la tabla
  source: Array<any> = [];
  // Contiene los controles de el formulario de pubblicaciones
  controls: BaseControl<any>[] = [];
  // Referencia del formulario
  form: FormGroup;
  // Contiene el formulario en el cual se registra la fecha para realizar el inventario documental
  formData: FormData = new FormData();
  //modal
  modalRef: BsModalRef;
  // Referencia al componente de confirmación modal
  @ViewChild("confirm") private confirm: ConfirmComponent;
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;
  //Referencia al modal personalizado
  @ViewChild("modalExp") modalExp: any;
  // Contiene el tab de pestañas de la tarea_asociacion
  @ViewChildren(TabsetComponent) staticTabs: QueryList<TabsetComponent>;
  // Contiene los rows seleccionados  
  selectedRows: any;
  // contiene el año ingresado
  year: number;
  // Pregunta de la modal de confirmaciones
  question = "";

  settingsModal = {};
  sourceModal: Array<any> = [];
  selectedModalrow: any;
  // documentos seleccionados
  documents: number[] = [];
  // bloquea el formulario de periodo de  inventario
  disbaleForm:boolean = false;
  // titulos 
  titleTable = "Listado de expedientes";
  // titulos bóton asociar
  titleButton = "Asociar expediente";
  // tipos de tablas
  typeTable = "";
  // tipos de consulta tabla
  typeTableSearch = "";
  // lebol del modal a mostrar
  labelModal = "";

  // labels de la tabla 

  //label para columna de numero de expediente
  labelNumeroExpedente = "Número";
  //label para fecha de expediente
  labelFechaNumeroExpediente = "Fecha";
  // label de la columna de expediente asociado
  labelExpediente = "Expediente";
  //label de la columna fecha de expediente asociado
  labelExpedienteFecha = "Fecha expediente";
  //controla el label de la fecha de vencimiento le expediente
  labelExpedienteVencimiento = "Fecha vencimiento"
  // controla el mensaje de cargando
  isLoading = false;

  //alerta de confirmacion
  alertaAsociacion = "";
  //alerta de finalizacion
  alertaValidacionFinalizacion = "";

  // Contiene el orden de las pestañas
  orderTabs: OrderTabsView[] = [
    {
      orden: 1,
      pestana: 'formularios',
      requerido: false,
      nombre: 'Formularios',
      view: true,
      modificable: true
    },
    {
      orden: 2,
      pestana: 'gestion_documentos',
      requerido: false,
      nombre: 'Generar / Subir documentos',
      view: false,
      modificable: false
    },
  ];
  // control que valida los documentos de la tarea
  docsValid = false;
  // controla el tab de documentos
  tabDocs = false;
  // Contiene las validaciones por documento
  condictionsDoc = {};
  // Extensiones de los archivos permitidas
  extensions: Array<String> = [
    'image/tiff-fx',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
    'image/jpg',
    'image/png',
    'image/jpeg',
    'image/tif',
    'image/tiff',
  ];
  // Label de las extensiones permitidas
  extensionsLabel = 'jpg, png, pdf, xlsx, xls, docx, doc, tiff, tif';

  // Define cuando abre la ventana de gestion de documentos
  wimdowManagementDocs = false;
  // Contiene los datos de todas las tablas inplicadas contando las tareas asociadas
  private _dataTableAll: TablaDatos[] = [];
  // Documentos descargados
  private _documentsDownload: any[] = [];
  // Documentos generados
  private _documentsGenerated: DocumentoGenerado[] = [];

  isDisabledBtnFinish: boolean;
  // control del formulario de periodo
  formDate = false;

  constructor(
    private toastr: ToastrService,
    private ddis: DocumentExpInventoryFormDataService,
    private modal: BsModalService,
    private sts: ScrollToService,
    private dis: DocumentExpInventoryFormService,
    ) {
    super();
  }

  async ngOnInit() {
    if(this.previewFlow){
      this.finishTask = true;
    }
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }
    this.isLoading = true;
    if(this.ctx['requerir_periodo']){
      let infoInventory = await this.ddis.getDocumentInventoryInfo({"tarea_id":this.task.id,"tipo":"periodo_inventario"});
      if (infoInventory){
        this.year = infoInventory['year'];
      }
      this.controls = this.dis.getFormDocumentInventory(this.year);
      this.formDate = true;
    }
    this.ddis.getTypeFormParameters().subscribe(async types => {
      if(types){
        Static.asyncForEach(types,async t => {
          if(this.ctx[t.nombre]){
            this.typeTable = t.nombre;
            let options = await this.ddis.getDocumentInventoryExpOptions({"labels":true,"tipo":t.nombre});
            if(options){
                this.typeTableSearch = options['typeTableSearch'];
                this.titleTable = options['titleTable'];
                this.titleButton = options['titleButton'];
                this.labelModal = options['labelModal'];
                this.labelNumeroExpedente = options['labelNumeroExpedente'];
                this.labelFechaNumeroExpediente = options['labelFechaNumeroExpediente'];
                this.labelExpediente = options['labelExpediente'];
                this.labelExpedienteFecha = options['labelExpedienteFecha'];
                this.alertaValidacionFinalizacion = options['alertaValidacionFinalizacion'];
                this.alertaAsociacion =  options['alertaAsociacion'];
                this.labelExpedienteVencimiento = options['labelExpedienteVencimiento']
            }
            const configTable = new DocumentExpInventoryFormConfig(this.labelNumeroExpedente,this.labelFechaNumeroExpediente,
              this.labelExpediente,this.labelExpedienteFecha, this.labelExpedienteVencimiento, this.formDate);
            this.settings = configTable.settings;
            this.settingsModal = configTable.settingsModal;
            let dataSend = {
                    "tarea_id": this.task.id,
                    "tipo": this.typeTable,
                    "inventario": true
                }
            this.source = await this.ddis.getDocumentInventory(dataSend);
            await Static.asyncForEach(this.source, async (registry: DocumentoInventario) => {
              if(registry.expediente){
                this.disbaleForm = true;
                if(this.form){
                  this.form.disable();
                }
                if(this.ctx['generar']){
                  this.tabDocs=true;
                  let tabIndex = findIndex(this.orderTabs, {pestana: 'gestion_documentos'});
                  this.orderTabs[tabIndex].view = true;
                }
              }
            });
            this.isLoading = false;
           
        }
        });
      }
    });
    this.validDocs();
  }

  /**
   * Finalizar la tarea.
   *
   * @param {boolean} res
   * @memberof DocumentExpInventoryFormComponent
   */
  finish(res: boolean) {
    if (res) {
      const data: ConfigFinishDefault = {
        tarea: this.task.id
      };
      const e: TaskEvent = {
        type: 'finish',
        data: data
      };
      this.event.emit(e);
      this.close();
    }
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof DocumentExpInventoryFormComponent
   */
  finishConfirm() {
    if (this.userResponsible && !this.finishTask && !this.secondaryActive) {
      if(this.ctx['generar']){
        if(this.disbaleForm && !this.isDisabledBtnFinish && this.docsValid){
          this.confirmFinish.open();
        }else{
          if(this.alertaValidacionFinalizacion){
            this.toastr.warning(
             this.alertaValidacionFinalizacion,
              'Acción no permitida'
            );
            }
          else{
            this.toastr.warning(
              'No se puede realizar esta acción debido a que no sean asociado documentos a expedientes',
              'Acción no permitida'
            );
          }
          
        }
      }else if (!this.ctx['generar']){
        if(this.disbaleForm && this.isDisabledBtnFinish){
          this.confirmFinish.open();
        }else{
          if(this.alertaValidacionFinalizacion){
            this.toastr.warning(
             this.alertaValidacionFinalizacion,
              'Acción no permitida'
            );
            }
          else{
            this.toastr.warning(
              'No se puede realizar esta acción debido a que no sean asociado documentos a expedientes',
              'Acción no permitida'
            );
          }
          
        }
      } 
      
      
    } else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }

     /**
   * contiene los rows seleccionados
   *
   * @param {*} event
   * @memberof DocumentExpInventoryFormComponent
   */
  onRowSelect(event: any) {
    this.selectedRows = event.selected;
  }

     /**
   * Metodo que realiza la asociacion masiva
   *
   * @return {*}
   * @memberof DocumentExpInventoryFormComponent
   */
  async associateExp() {
    this.documents.length = 0;
    if (this.selectedRows){
        this.selectedRows.forEach((d: DocumentoInventario) => {
            if (!d.expediente) {
              this.documents.push(d.id);
            }
          });
        if(this.documents.length){
          let dataSend = {
            "tarea_id": this.task.id,
            "inventario": false,
            "tipo": this.typeTableSearch
        };
          this.sourceModal.length = 0;
          this.sourceModal = await this.ddis.getDocumentInventoryExp(dataSend);
          this.modalRef = this.modal.show(this.modalExp, {
              class: "modal-lg-personalized",
              ignoreBackdropClick: true,
        });
        }else{
          this.toastr.warning("Debe seleccionar registros que no esten asociados", 'Advertencia');
        }
          
    } 
  }

  /**
   *Cierra la modal
   *
   * @memberof DocumentExpInventoryFormComponent
   */
   closeModal(){
    this.selectedModalrow = null;
    this.modalRef.hide();
  }

  /**
   * contiene los rows seleccionados dentro del modal
   *
   * @param {*} event
   * @memberof DocumentExpInventoryFormComponent
   */
   async onRowModalSelect(event: any) {
    this.selectedModalrow = null;
    this.selectedModalrow = await event.selected;
  }

  /**
   * contiene los rows seleccionados dentro del modal
   *
   * @param {*} event
   * @memberof DocumentExpInventoryFormComponent
   */
   associateExpSelection() {
     if (this.selectedModalrow != null && this.selectedModalrow.length){
      if(this.alertaAsociacion){
        this.question = "¿"+this.alertaAsociacion+" "+this.selectedModalrow[0].numero+" ?";
      }else{
        this.question = "¿Realmente desea asociar los documentos al expediente: "+this.selectedModalrow[0].numero+" ?";
      }
      
      this.confirm.open();
     }
  }

 /**
   * respuesta dada desde el modal de confirmacion
   *
   * @param {*} res
   * @memberof DocumentExpInventoryFormComponent
   */
  async actionComfirm(res: boolean) {
    if (res) {
      if (this.selectedModalrow) {
        let dataSend = {
          "tarea_id": this.task.id,
          "id_documentos": this.documents,
          "id_expediente": this.selectedModalrow[0].id,
          "tipo": this.typeTable
        };
        let result = await this.ddis.sendDocumentsInfo(dataSend);
        if(result){
          this.selectedModalrow = null;
          let dataSend = {
            "tarea_id": this.task.id,
            "tipo": this.typeTable,
            "inventario": true
          };
          this.source = await this.ddis.getDocumentInventory(dataSend);
          this.closeModal();
          this.documents.length = 0;
          await Static.asyncForEach(this.source, async (registry: DocumentoInventario) => {
              if(registry.expediente){
                this.disbaleForm = true;
                this.form.disable();
                let acutalTab = findIndex(this.orderTabs, {pestana: 'formularios'})
                if(acutalTab){
                  this.orderTabs[acutalTab].complete = true;
                 
                }
                if(this.ctx['generar']){
                  this.tabDocs=true;
                  let tabIndex = findIndex(this.orderTabs, {pestana: 'gestion_documentos'});
                  this.orderTabs[tabIndex].view = true;
                  if(acutalTab != undefined){
                    this.selectTab((acutalTab + 1), true);
                    this.selectTab((acutalTab + 1), false);
                  }
                }
              }
            });

        }
      }
    }
  }

  /**
   * Mantiene las pestañas principoales con las pestañas del contenedor fijo sincronizadas
   *
   * @param {number} tabId
   * @param {boolean} [staticTab=true]
   * @memberof DynamicFormsComponent
   */
   selectTab(tabId: number, staticTab: boolean = true) {
    if (this.staticTabs && this.staticTabs.length) {
      if (staticTab) {
        this.staticTabs.first.tabs[tabId].active = true;
      } else {
        this.staticTabs.last.tabs[tabId].active = true;
      }
    }
  }

  set dataTableAll(table: TablaDatos[]) {
    this._dataTableAll = table;
  }

  get dataTableAll() {
    return this._dataTableAll;
  }

  set documentsDownload(docs: any[]) {
    this._documentsDownload = docs;
    this.validDocs();
  }

  get documentsDownload(): any[] {
    return this._documentsDownload;
  }

  set documentsGenerated(docs: DocumentoGenerado[]) {
    this._documentsGenerated = docs;
    this.validDocs();
  }

  get documentsGenerated(): DocumentoGenerado[] {
    return this._documentsGenerated;
  }

  /**
   * Controla el evento de cerrar la ventana de documentos
   *
   * @param {boolean} res
   * @memberof DynamicFormsComponent
   */
   closeDocs(res: boolean) {
    if (res) {
      this.wimdowManagementDocs = false;
    }
    setTimeout(() => {
      this.scrollForm('headertask');
      }
    );
  }

  /**
   * Posiciona el scroll a la caja deseada
   *
   * @param {string} positionScroll
   * @memberof DynamicFormsComponent
   */
   scrollForm(positionScroll: string) {
    if (positionScroll) {
      this.sts.scrollTo({
        target: positionScroll
      } as ScrollToConfigOptions);
    }
  }

  /**
   * Valida que todos los documentos se hayan subido y activa el boton de finalizar
   *
   * @memberof ElaborateComponent
   */
   validDocs() {
    let valid = true;
    if (this.task.documentos.length > 0) {
      for (let indexDoc = 0; indexDoc < this.task.documentos.length; indexDoc++) {
        let validUpload = false;
        let validGenerate = false;
        if (this.task.documentos[indexDoc].funciones.length > 0) {
          for (let indexFuntion = 0;
            indexFuntion < this.task.documentos[indexDoc].funciones.length;
            indexFuntion++) {
            if (
              this.task.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.upload ||
              this.task.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.dowload 
            ) {
              if (this.task.documentos[indexDoc].funciones[indexFuntion].obligatorio) {
                validUpload = true;
                break;
              }
            }
          }
          const generateDoc = find(this.task.documentos[indexDoc].funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.generate});
          if(generateDoc && generateDoc.obligatorio){
            validGenerate = true;
          }
        }
        if (validUpload) {
          const uploadDoc = find(this.task.documentos[indexDoc].funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.upload});
          if (uploadDoc) {
            if (this.task.documentos[indexDoc].documentos_detalle.length > 0) {
              if (this.task.documentos[indexDoc].documentos_detalle[0].hasOwnProperty('historial')) {
                if (this.task.documentos[indexDoc].documentos_detalle[0].historial.length > 0) {
                  const versionDoc = this.task.documentos[indexDoc].documentos_detalle[0].historial.length;
                  for (let indexHistory = 0;
                    indexHistory < this.task.documentos[indexDoc].documentos_detalle[0].historial.length;
                    indexHistory++) {
                    if (this.task.documentos[indexDoc]
                      .documentos_detalle[0].historial[indexHistory].version === versionDoc) {
                      if (this.task.documentos[indexDoc]
                        .documentos_detalle[0].historial[indexHistory].revision.length) {
                        let idReview = 0;
                        for (let indexReview = 0;
                          indexReview < this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory].revision.length;
                          indexReview++) {
                          if (this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory]
                            .revision[indexReview].id_revision > idReview) {
                            idReview = this.task.documentos[indexDoc]
                              .documentos_detalle[0].historial[indexHistory]
                              .revision[indexReview].id_revision;
                          }
                        }
                        for (let indexReview = 0;
                          indexReview < this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory].revision.length;
                          indexReview++) {
                          if (this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory]
                            .revision[indexReview].id_revision === idReview) {
                            if (!this.task.documentos[indexDoc]
                              .documentos_detalle[0].historial[indexHistory]
                              .revision[indexReview].revision) {
                              valid = false;
                              break;
                            } else {
                              valid = true;
                            }
                          }
                        }
                        if (!valid) {
                          break;
                        }
                      } else {
                        const currentSourceDocuments = filter(
                          this.task.documentos[indexDoc].documentos_detalle[0].historial,
                          {tarea_origen: this.task.id}
                        );
                        if (currentSourceDocuments && currentSourceDocuments.length) {
                          valid = true;
                        } else {
                          valid = false;
                          break;
                        }
                      }
                    }
                  }
                } else {
                  valid = false;
                  break;
                }
              } else {
                valid = false;
                break;
              }
            } else {
              valid = false;
              break;
            }
          } else {
            if (this.task.documentos[indexDoc].documentos_detalle.length > 0) {
              const doc = findIndex(
                this.documentsDownload,
                el => el === this.task.documentos[indexDoc].documentos_detalle[0].id_documento
              );
              if (doc !== -1) {
                valid = true;
              } else {
                valid = false;
                break;
              }
            } else if (this.documentsGenerated.length) {
              const doc = findIndex(
                this.documentsGenerated,
                {
                  idtarea: this.task.id,
                  clasificacion_id: this.task.documentos[indexDoc].clasificacion_id
                }
              );
              if (doc !== -1) {
                valid = true;
              } else {
                valid = false;
                break;
              }
            } else {
              valid = false;
              break;
            }
          }
        }
        if (validGenerate && !validUpload){
          if(this.documentsGenerated.length){
            const doc = findIndex(
              this.documentsGenerated,
              {
                idtarea: this.task.id,
                clasificacion_id: this.task.documentos[indexDoc].clasificacion_id
              }
            );
            if (doc !== -1) {
              valid = true;
            } else {
              valid = false;
              break;
            }
          }else{
            valid = false;
              break;
          }
        }
        if (!valid) {
          break;
        }
      }
    }
    if (valid) {
      if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
        for (const taskAssociation of this.task.tarea_asociacion) {
          if (taskAssociation.documentos.length > 0) {
            for (let indexDoc = 0; indexDoc < taskAssociation.documentos.length; indexDoc++) {
              let validUpload = false;
              if (taskAssociation.documentos[indexDoc].funciones.length > 0) {
                for (let indexFuntion = 0;
                  indexFuntion < taskAssociation.documentos[indexDoc].funciones.length;
                  indexFuntion++) {
                    if (
                      // tslint:disable-next-line: max-line-length
                      taskAssociation.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.upload ||
                      // tslint:disable-next-line: max-line-length
                    taskAssociation.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.dowload
                  ) {
                    if (taskAssociation.documentos[indexDoc].funciones[indexFuntion].obligatorio) {
                      validUpload = true;
                      break;
                    }
                  }
                }
              }
              if (validUpload) {
                const uploadDoc = find(
                  taskAssociation.documentos[indexDoc].funciones,
                  {funcion: Const.DOCUMENTS_FUNCTIONS.upload}
                );
                if (uploadDoc) {
                  if (taskAssociation.documentos[indexDoc].documentos_detalle.length > 0) {
                    if (taskAssociation.documentos[indexDoc].documentos_detalle[0].hasOwnProperty('historial')) {
                      if (taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length > 0) {
                        const versionDoc = taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length;
                        for (let indexHistory = 0;
                          indexHistory < taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length;
                          indexHistory++) {
                          if (taskAssociation.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory].version === versionDoc) {
                            if (taskAssociation.documentos[indexDoc]
                              .documentos_detalle[0].historial[indexHistory].revision.length) {
                              let idReview = 0;
                              for (let indexReview = 0;
                                indexReview < taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory].revision.length;
                                indexReview++) {
                                if (taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory]
                                  .revision[indexReview].id_revision > idReview) {
                                  idReview = taskAssociation.documentos[indexDoc]
                                    .documentos_detalle[0].historial[indexHistory]
                                    .revision[indexReview].id_revision;
                                }
                              }
                              for (let indexReview = 0;
                                indexReview < taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory].revision.length;
                                indexReview++) {
                                if (taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory]
                                  .revision[indexReview].id_revision === idReview) {
                                  if (!taskAssociation.documentos[indexDoc]
                                    .documentos_detalle[0].historial[indexHistory]
                                    .revision[indexReview].revision) {
                                    valid = false;
                                    break;
                                  } else {
                                    valid = true;
                                  }
                                }
                              }
                              if (!valid) {
                                break;
                              }
                            } else {
                              const currentSourceDocuments = filter(
                                taskAssociation.documentos[indexDoc].documentos_detalle[0].historial,
                                {tarea_origen: this.task.id}
                              );
                              if (currentSourceDocuments && currentSourceDocuments.length) {
                                valid = true;
                              } else {
                                valid = false;
                                break;
                              }
                            }
                          }
                        }
                      } else {
                        valid = false;
                        break;
                      }
                    } else {
                      valid = false;
                      break;
                    }
                  } else {
                    valid = false;
                    break;
                  }
                } else {
                  if (taskAssociation.documentos[indexDoc].documentos_detalle.length > 0) {
                    const doc = findIndex(
                      this.documentsDownload,
                      el => el === taskAssociation.documentos[indexDoc].documentos_detalle[0].id_documento
                    );
                    if (doc !== -1) {
                      valid = true;
                    } else {
                      valid = false;
                      break;
                    }
                  } else if (this.documentsGenerated.length) {
                    const doc = findIndex(
                      this.documentsGenerated,
                      {
                        idtarea: taskAssociation.id_tarea_destino,
                        clasificacion_id: taskAssociation.documentos[indexDoc].clasificacion_id
                      }
                    );
                    if (doc !== -1) {
                      valid = true;
                    } else {
                      valid = false;
                      break;
                    }
                  } else {
                    valid = false;
                    break;
                  }
                }
              }
              if (!valid) {
                break;
              }
            }
            if (!valid) {
              break;
            }
          }
        }
      }
    }
    if (valid) {
      this.docsValid = true;
      this.isDisabledBtnFinish = false;
    } else {
      this.isDisabledBtnFinish = true;
      this.docsValid = false;
    }
  }

   /**
   * actualiza la informacion de la tarea con respecto a los documentos subidos
   *
   * @param {*} data
   * @returns {*}
   * @memberof ElaborateComponent
   */
  documentUpdate(data: Documento[]): any {

    data.forEach(newDoc => {
      // Copiando funciones del documento
      const functionD: FuncionDocumento[] = [];
      newDoc.funciones.forEach(fun => {
        functionD.push({
          funcion: fun.funcion,
          id_funcion: fun.id_funcion,
          obligatorio: fun.obligatorio
        });
      });
      // Copienado documentos detalle del documento
      const detailDocument: DocumentoDetalle[] = [];
      newDoc.documentos_detalle.forEach(detail => {
        // Copiando historial del docuemnto
        const record: HistorialDocumento[] = [];
        if (detail.historial && detail.historial.length) {
          detail.historial.forEach(history => {
            // Copiando revisiones del registro de historial del documento
            const revisions: RevisionDocumento[] = [];
            if (history.revision && history.revision.length) {
              history.revision.forEach(revision => {
                revisions.push({
                  id_revision: revision.id_revision,
                  id_tarea: revision.id_tarea,
                  reponsable_id: revision.reponsable_id,
                  nombre_tarea: revision.nombre_tarea,
                  descripcion: revision.descripcion,
                  nombre_responsable: revision.nombre_responsable,
                  apellidos_responsable: revision.apellidos_responsable,
                  fecha: revision.fecha,
                  revision: revision.revision,
                  historial_id: revision.historial_id,
                  version: revision.version,
                  opcion: revision.opcion
                });
              });
            }
            record.push({
              id: history.id,
              nombre: history.nombre,
              nombre_archivo: history.nombre_archivo,
              extension: history.extension,
              version: history.version,
              revision: revisions,
              radicado: history.radicado,
              tarea_origen: history.tarea_origen
            });
          });
        }
        detailDocument.push({
          fecha: detail.fecha,
          folios: detail.folios,
          historial: record,
          id_documento: detail.id_documento,
          radicado: detail.radicado,
          documento_cita: detail.documento_cita,
          id_documento_cita: detail.id_documento_cita,
        });
      });
      // Copiando documento
      const doc: Documento = {
        clasificacion: newDoc.clasificacion,
        clasificacion_id: newDoc.clasificacion_id,
        codigo_documento: newDoc.codigo_documento,
        documentos_detalle: detailDocument,
        funciones: functionD,
        id_tipo_documental: newDoc.id_tipo_documental,
        id_expediente_cita: newDoc.id_expediente_cita,
        ruta_generacion: newDoc.ruta_generacion,
        ruta_vista_previa: newDoc.ruta_vista_previa,
        tipo_documental: newDoc.tipo_documental,
      };
      this.ctx.task.documentos.forEach((document, index) => {
        if (this.task.id === newDoc.idtarea && document.clasificacion_id === newDoc.clasificacion_id) {
          this.ctx.task.documentos[index] = doc;
        }
      });
      if (this.ctx.task.tarea_asociacion && this.ctx.task.tarea_asociacion.length) {
        this.ctx.task.tarea_asociacion.forEach(taskAssociation => {
          taskAssociation.documentos.forEach((document, index) => {
            if (
              taskAssociation.id_tarea_destino === newDoc.idtarea &&
              document.clasificacion_id === newDoc.clasificacion_id
            ) {
              taskAssociation.documentos[index] = doc;
            }
          });
        });
      }
    });
    this.updateTask(this.ctx.task);
    this.validDocs();
  }

    /**
   * Metodo que organiza el formData y modifica una publicacion
   *
   * @memberof DocumentInventoryFormComponent
   */
     async sended() {
      if (this.form.valid) {
        let parameters = {
          "year": Number(this.form.controls['fecha_inventario'].value),
          "tarea_id": this.task.id,
          "tipo": "registrar_periodo_inventario"
        }
        let result = await this.ddis.sendDocumentsOptionsInfo(parameters)
        if (result){
          this.year = this.form.controls['fecha_inventario'].value;
          let dataSend = {
            "tarea_id": this.task.id,
            "tipo": this.typeTable,
            "inventario": true
        }
          this.source = await this.ddis.getDocumentInventory(dataSend);
        }
      }
    }
}


// WEBPACK FOOTER //
// ./src/app/forms/all/document-exp-inventory-form/document-exp-inventory-form.component.ts